import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';

export const dinnersCountColumn = <T extends { dinnersCount: number }>(
  t: TFunction,
): ColumnType<T> => ({
    title: t('Dinners count'),
    dataIndex: 'dinnersCount',
  });
